var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#FFF4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#FFF4E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_9038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6237 12.0142L20.8037 12.1195C21.1583 12.327 21.2798 12.7865 21.075 13.1459L19.5439 15.8336C19.3392 16.1929 18.8858 16.3161 18.5313 16.1086L18.3512 16.0032C17.8636 15.7179 17.5354 15.2182 17.4637 14.6522C17.412 14.2436 16.9835 14.0035 16.6146 14.1766L16.1499 14.3945C15.9592 14.484 15.7375 14.4738 15.5554 14.3673L12.8444 12.9554C12.5799 12.8006 12.4584 12.4794 12.5531 12.1851L12.7565 11.3365C12.8197 11.1403 12.7399 10.9224 12.5531 10.8403C11.0621 10.1845 8.82581 11.2087 8.82581 10.0765C8.82581 8.94422 12.5834 7.48394 15.079 8.94423L17.8287 10.3787C18.0107 10.4852 18.1294 10.6744 18.1484 10.8865L18.1945 11.4033C18.2311 11.8136 18.6504 12.0697 19.0255 11.9108C19.5449 11.6906 20.136 11.7289 20.6237 12.0142Z",
    stroke: "#ED6C02",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6631 12.7773L8.43782 20.2713C8.23517 20.586 8.33476 21.0086 8.65585 21.1964L9.83525 21.8865C10.1563 22.0744 10.5672 21.9505 10.7348 21.6153L14.9358 13.9771",
    stroke: "#ED6C02",
    strokeWidth: 1.11111
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_9038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionWorker);
export default __webpack_public_path__ + "static/media/construction-worker.be5454981c73b23e744f648a92b4a1b4.svg";
export { ForwardRef as ReactComponent };